import gql from "graphql-tag";

export const updateFeatureMutation = gql`
  mutation updateFeature(
    $id: ID!
    $name: String
    $code: String
    $isActive: Boolean
    $customers: [ID!]
  ) {
    updateFeature(id: $id, name: $name, code: $code, isActive: $isActive, customers: $customers) {
      id
    }
  }
`;
